import axios from 'axios';

const headers = {
    'Authorization': 'Bearer 545',
};

export default class HttpService {
    static get(url: string) {
        return axios.get(url, {
            headers,
        }).then(value => {
            return value.data;
        }).catch(error => {
            return error;
        });
    }

    static post(url: string, data: any) {
        return axios.post(url, data, {
            headers,
        }).then(value => {
            return value.data;
        }).catch(error => {
            return error;
        });
    }

    static put(url: string, data: any) {
        return axios.put(url, data, {
            headers,
        }).then(value => {
            return value.data;
        }).catch(error => {
            return error;
        });
    }

    static delete(url: string) {
        return axios.delete(url, {
            headers,
        }).then(value => {
            return value.data;
        }).catch(error => {
            return error;
        });
    }
}
